<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Transaction Types Charges"
              bc1="App"
              bc2="Transaction Types Charges"
              bc3="List"
              path="schemas"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="card" >
          <h5 class="card-header">Replicate Charges</h5>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_plan">
              <InfiniteSelect
                  api-url="v1/get-schema"
                  ref="schemaInfiniteSelect"
                  :request-params="schemaRequestParams"
                  :formatter="(item) => item?.description? item.name + '/' + item.code + ' (' + item.description + ')' : item.name + '/' + item.code "
                  key-field="id"
                  @selectedFullObj="(item) => selectedSchema = item"
                  placeholder-text="Select a schema..."
              />
            </div>
            <div class="col-md-4 user_plan">
              <select class="form-control mr-1" v-model="selectedAcquiring">
                <option :value="null" selected>Select Acquiring</option>
                <option :key="index" :value="option" v-for="(option, index) in schemaAquirings">
                  {{option?.aquiring?.name +'/'+ option?.aquiring?.code}}
                </option>
              </select>
            </div>
            <div class="col-md-4 user_plan">
              <select class="form-control mr-1" v-model="selectedType">
                <option :value="null" selected>Select Transaction Type</option>
                <option :key="index" :value="option" v-for="(option, index) in transactionTypesList">
                  {{option.name}}
                </option>
              </select>
            </div>
          </div>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_status">
              <button :disabled="!selectedType" type="button" class="btn btn-primary" @click="showConfirmationModal = true" >Replicate Charges</button>
            </div>

          </div>
        </div>
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="d-flex align-items-center">
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a href="javascript:void(0)">Schema</a></li>
                      <li class="breadcrumb-item" v-for="(crumb,index) in currentBreadCrumb">{{crumb}}</li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-success btn-sm"
                      @click="showPdfDownloadConfirmationModal = true">
                    <span class="text-nowrap">Download PDF</span>
                  </button>
                  <button
                      type="button"
                      class="btn btn-primary btn-sm ml-1"
                      @click="addRecord"
                  >
                    <span class="text-nowrap">Add Charge</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2 mb-1">
            <div class="col-12 d-flex justify-content-end">
              <button
                  v-if="transaction_types_charges?.length != 0"
                  type="button"
                  class="btn btn-danger btn-sm mr-1"
                  @click="showRemoveAllChargesModal = true">
                <span class="text-nowrap">Remove All Charges</span>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Status</th>
                      <th>Apply In Limits</th>
                      <th>Name</th>
                      <th>Charge Type</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                      <th>Action</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="transaction_types_charges?.length == 0">
                      <td
                          colspan="8"
                          class="font-weight-bolder font-medium-2"
                          style="text-align: center"
                      >
                        <div class="spinner-border spinner-border-sm text-primary" v-show="loading" ></div>
                        No data available
                      </td>
                    </tr>
                    <tr v-for="(item,index) in transaction_types_charges" :key="index">

                      <td>{{ index + 1 }}</td>
                      <td v-if="item.status == 1"><span class="badge badge-success badge-sm badge-glow">Active</span></td>
                      <td v-else><span class="badge badge-danger badge-sm badge-glow">Inactive</span></td>
                      <td>
                        <div class="row">
                          <div class="col-12">
                            <span v-if="item.apply_in_limits == 1" class="badge badge-light-success badge-sm badge-glow">Yes</span>
                            <span v-else class="badge badge-light-warning badge-sm badge-glow">No</span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div class="badge badge-dark mt-1" @click="showDetails(item)" style="cursor: pointer;">View Charges</div>
                          </div>
                        </div>
                      </td>
                      <td>{{ item.charge.name }}</td>
                      <td>{{ item.charge.type }}</td>
                      <td>{{ customFormatDateTime(item.created_at) }}</td>
                      <td>{{ customFormatDateTime(item.updated_at) }}</td>
                      <td class="d-flex">
                        <button class="btn btn-warning btn-sm" @click="showUpdate(item,index)">Update</button>
                        <button class="btn btn-danger btn-sm ml-1" @click="removeField(item,index)">Remove</button>
                      </td>


                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TransactionTypeChargesDetailsModal  :data="detailsData"
                          :show="showDetailsModal"
                          @hide="showDetailsModal = false" />
    <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" message="Are you sure to replicate the charge?"
                       title="Replicate Charge"
                       @hide="showConfirmationModal = false"></ConfirmationModal>

    <ConfirmationModal :show="showPdfDownloadConfirmationModal" @confirm="downloadPDF" message="Are you sure to download the pdf?"
                       title="Download PDF"
                       @hide="showPdfDownloadConfirmationModal = false"></ConfirmationModal>

    <ConfirmationModal :show="showRemoveChargeConfirmationModal" @confirm="removeFieldWithApi" message="Are you sure to remove the charge?"
                       title="Remove Charge"
                       @hide="showRemoveChargeConfirmationModal = false; selectedItemToRemove = null"></ConfirmationModal>

    <ConfirmationModal :show="showRemoveAllChargesModal" @confirm="removeAllCharges" message="Are you sure to remove all the charges?"
                       title="Remove All Charges"
                       @hide="showRemoveAllChargesModal = false"></ConfirmationModal>


    <div id="printable-area" style="display: none;">
      <h2 style="text-align: center; margin-bottom: 10px;">Transaction Type Charges</h2>

      <div style="text-align: center; font-style: italic;">
        (
        <span v-if="currentBreadCrumb && currentBreadCrumb.length">
      Schema
      <span v-for="(crumb, index) in currentBreadCrumb" :key="index">
        &nbsp;&gt;&nbsp;{{ crumb }}
      </span>
    </span>
        )
      </div>
      <div style="text-align: center; margin-bottom: 30px; font-style: italic;">
        (
        <span v-if="currentBreadCrumb && currentBreadCrumb.length">
      Groups
      <span>{{schemaAllGroupsFromApi.join(' | ')}}</span>
    </span>
        )
      </div>

      <div v-for="(item, index) in transaction_types_charges" :key="index" class="mb-3">
        <h5>{{ index + 1 }}) {{ item.charge.name }} ({{ item.charge.type }})</h5>
        <p>Status: {{ item.status == 1 ? 'Active' : 'Inactive' }}</p>
        <p>Apply in Limits: {{ item.apply_in_limits == 1 ? 'Yes' : 'No' }}</p>

        <!-- Charges Table -->
        <table border="1" cellspacing="0" cellpadding="5" width="100%">
          <thead>
          <tr>
            <th>S.No</th>
            <th>Charges</th>
            <th>Charge Type</th>
            <th>Gateway Charges</th>
            <th>GW Charge Type</th>
            <th v-if="item.apply_in_limits == 1">Amount</th>
            <th v-if="item.apply_in_limits == 1">Condition</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, i) in item.charges" :key="i">
            <td>{{ i + 1 }}</td>
            <td>{{ row.charges }}</td>
            <td>{{ row.type }}</td>
            <td>{{ row.gwcharges }}</td>
            <td>{{ row.gwType }}</td>
            <td v-if="item.apply_in_limits == 1">{{ parseFloat(row.amount / 100).toFixed(feesDecimalPlaces) }}</td>
            <td v-if="item.apply_in_limits == 1">{{ row.condition }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>


  </div>
  <!-- END: Content-->
</template>

<script>


import ChargesDetailsModal from "@/pages/dashboard/charges/chargesDetailsModal.vue";
import TransactionTypeChargesDetailsModal from "@/pages/dashboard/schema/transactionTypeChargesDetailsModal.vue";
import html2pdf from "html2pdf.js";
import InfiniteSelect from "@/components/common/InfiniteSelect.vue";

export default {
  components: {InfiniteSelect, TransactionTypeChargesDetailsModal, ChargesDetailsModal},
  mounted() {
    this.storeData.acquiringSchemaDetailsList = this.$store.getters.getByKey(
        "acquiringSchemaDetailsList"
    );


    this.storeData.schemaAcquiringTransactionTypes = this.$store.getters.getByKey(
        "schemaAcquiringTransactionTypes"
    );



    this.storeData.schemaAcquiringTransactionTypesCharges = this.$store.getters.getByKey(
        "schemaAcquiringTransactionTypesCharges"
    );

    this.currentBreadCrumb.push(this.storeData.acquiringSchemaDetailsList.row.name+'/'+this.storeData.acquiringSchemaDetailsList.row.code)
    this.currentBreadCrumb.push(this.storeData.schemaAcquiringTransactionTypes.row.aquiring.name+'/'+this.storeData.schemaAcquiringTransactionTypes.row.aquiring.code)
    this.currentBreadCrumb.push(  this.storeData.schemaAcquiringTransactionTypesCharges.row.name)

    this.schemaAquiringId = parseInt(atob(this.$route.params.acquiringId))
    this.aquiringTransactionTypeId = this.storeData.schemaAcquiringTransactionTypesCharges.row.pivot.id

    this.getTransactionTypeCharges()

    this.selectedItemToRemove = null
    this.selectedIndexToRemove = null

  },
  data() {
    return {
      schemaRequestParams: {},
      showRemoveChargeConfirmationModal:false,
      showConfirmationModal:false,
      transaction_types_charges: [],
      aquiringTransactionTypeId: '',
      schemaAquiringId: '',
      currentBreadCrumb:[],
      showDetailsModal: false,
      detailsData:{},
      selectedType:null,
      selectedSchema: null,
      schemaAquirings:[],
      transactionTypesList:[],
      selectedAcquiring:null,
      showPdfDownloadConfirmationModal:false,
      showRemoveAllChargesModal:false,
      loading: false,
      selectedIndexToRemove:null,
      selectedItemToRemove:null,
      schemaAllGroupsFromApi:[],
      storeData: {
        acquiringSchemaDetailsList: null,
        schemaAcquiringTransactionTypes: null,
        schemaAcquiringTransactionTypesCharges: null
      }

    };
  },
  methods: {
    removeAllCharges(){
      let payload = {
        schemaAquiringId: this.schemaAquiringId,
        aquiringTransactionTypeId: this.aquiringTransactionTypeId,
      }
      this.makeRequest(
          "post",
          "v1/delete-schema-aquiring-charges",
          payload
      ).then(callResponse => {
        this.showRemoveAllChargesModal = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.transaction_types_charges = [];
          }
        }
      })
    },
    async downloadPDF() {

      this.$store.dispatch('exportExcelLoader', true)
      await this.getSchemaGroups()

      const schemaName = this.storeData.acquiringSchemaDetailsList.row.name || 'Unknown Schema';
      const acquiringName = this.storeData.schemaAcquiringTransactionTypes.row.aquiring.name || 'Unknown Acquiring';
      const transactionTypeName = this.storeData.schemaAcquiringTransactionTypesCharges.row.name || 'Unknown Transaction Type';
      const firstGroupName = this.schemaAllGroupsFromApi[0] || 'Unknown Group';

      const fileName = `${firstGroupName} - ${schemaName} - ${acquiringName} - ${transactionTypeName}.pdf`;

      const element = document.getElementById('printable-area');
      element.style.display = 'block'; // Make it visible temporarily

      html2pdf()
          .from(element)
          .set({
            margin: 0.5,
            filename: fileName,
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
          })
          .save()
          .then(() => {
            element.style.display = 'none'; // Hide again after download
            this.showPdfDownloadConfirmationModal = false
          });

      this.$store.dispatch('exportExcelLoader', false)


    },
    confirm(){
      this.$store.dispatch('exportExcelLoader', true)
      let data = {
        schemaAquiringId: this.schemaAquiringId,
        aquiringTransactionTypeId: this.aquiringTransactionTypeId,
        repChargesSchemaAquiringId: this.selectedAcquiring?.id,
        repChargesAquiringTransactionTypeId: this.selectedType?.pivot?.id,
        replicateCharges:1
      }
      this.makeRequest("post", "v1/add-schema-aquiring-charges", data).then(
          callResponse => {
            this.$store.dispatch('exportExcelLoader', false)
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                window.location.reload()
              }
            }
          }
      );
    },
    showDetails(item){
      this.detailsData = item
      this.showDetailsModal = true
    },
    showUpdate(item,index){
      let data = {
        index: index,
        row: item,
        key: "updateSchemaAcquiringTransactionTypesCharges"
      };
      this.$store.dispatch("set", data);
      this.$router.push({name: 'update-schema-transction-type-charges'})
    },
    removeField(item,index){
      this.selectedItemToRemove = item
      this.selectedIndexToRemove = index
      this.showRemoveChargeConfirmationModal = true
    },
    removeFieldWithApi(){
      if(!this.selectedItemToRemove){
        return
      }

      let item = this.selectedItemToRemove
      let index = this.selectedIndexToRemove
      let data = {
        schemaAquiringChargeId: item.id,
      }
      this.makeRequest(
          "post",
          "v1/delete-schema-aquiring-charges",
          data
      ).then(callResponse => {
        this.selectedItemToRemove = null
        this.showRemoveChargeConfirmationModal = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.transaction_types_charges.splice(index, 1);
          }
        }
      })

    },
    addRecord(){
      this.$router.push({name:'add-schema-transction-type-charges',params: {acquiringId : btoa(this.schemaAquiringId)}})
    },
    getTransactionTypeCharges() {
      let data = {
        aquiringTransactionTypeId: this.aquiringTransactionTypeId,
        schemaAquiringId: this.schemaAquiringId,
      }
      this.loading = true
      this.makeRequest(
          "post",
          "v1/get-schema-aquiring-charges",
          data,
          {},
          false
      ).then(callResponse => {
        this.loading = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.transaction_types_charges = callResponse.response.data.data ?? []
          }
        }
      });
    },
    async getSchemaGroups() {
      var acquiringSchemaDetailsList = this.$store.getters.getByKey(
          "acquiringSchemaDetailsList"
      );

      let data = {
        schemaId: acquiringSchemaDetailsList.row.id,
        status:'all'
      }
      await this.makeRequest(
          "post",
          "v1/get-schema-groups",
          data,
          {},
          false
      ).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let data = callResponse.response.data.data;
            if(data){
              data.forEach(v => {
                this.schemaAllGroupsFromApi.push(v.name)
              });
            }
          }
        }
      });
    },
  },
  watch:{
    selectedSchema(val){
      this.transactionTypesList = []
      this.schemaAquirings = []
      this.selectedAcquiring = null
      this.selectedType = null

      if(val){
        this.schemaAquirings = val.schema_aquirings
      }
    },
    selectedAcquiring(val){
      this.transactionTypesList = []
      this.selectedType = null
      if(val && val.aquiring){
        this.transactionTypesList = val.aquiring.transaction_types
      }
    },
  }

};
</script>

